
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from '../core/api/api.service';
import { Observable } from 'rxjs';
import { PartnersBackend } from './partners.backend';
import { TasksBackend } from './tasks.backend';
import { getStateBitMask } from '../core/helpers';

@Injectable()
export class MarketingCampaignBackend {


  constructor(private _api: ApiService, private partnersBackend: PartnersBackend, private tasksBackend: TasksBackend) {
  }

  private filterExecutorStr(value: any): any {
    if (!value) return null;
    
    // Handle single value
    if (value === "1" || value === 1) return null;
    
    // Handle array
    if (Array.isArray(value)) {
      const filtered = value.filter(v => v !== "1" && v !== 1);
      return filtered.length > 0 ? filtered : null;
    }
    
    // Handle string (could be comma-separated)
    if (typeof value === 'string') {
      const parts = value.split(',').map(p => p.trim()).filter(p => p !== "1");
      return parts.length > 0 ? parts.join(',') : null;
    }
    
    return value;
  }

  getAllMarketingTasksSavedPars;
  getCampaignsMarketingTasksSavedPars;

  getMarketingCampaignsList(params): Observable<any[]> {
    const pars: any = {};
    pars.dateTo = params.to;
    pars.dateFrom = params.from;
    pars.startFrom = params.startFrom;
    pars.pageLength = params.pageLength;
    pars.orderBy = params.orderBy;
    pars.orderDir = params.orderDir;
    const filteredExecutors = this.filterExecutorStr(params.executors);
    if (filteredExecutors) {
      pars.executorStr = filteredExecutors;
    }
    params.search ? pars.filter = params.search : null;
    // pars.statesBitmask = getStateBitMask(params);
    // pars.clientTypeIdStr = params.clientTypesList;
    // pars.sourceIdStr = params.sourcesList;
    // pars.taskTypeId = params.taskTypeId;
    params.products ? pars.productStr = params.products : null;
    return <any>this._api.getAuth('tasks/campaign', pars).pipe(map((res: any) => res.body));
  }

  getMarketingCampaign(id) {
    // let httpParams = new HttpParams();
    // httpParams.append('campaignsId', id);
    return <any>this._api.getAuth(`tasks/campaign`, { campaignsId: id }).pipe(map((res: any) => res.body));
  }

  editMarketingCampaign(marketingCampaign) {
    return <any>this._api.postAuth('tasks/campaign', marketingCampaign).pipe(map((res: any) => res.body));
  }

  // createMarketingCampaign(marketingCampaign) {
  //   return <any>this._api.postAuth('marketingCampaigns/create', marketingCampaign).pipe(map((res: any) => res.body));
  // }

  getProducts() {
    return this.partnersBackend.getRequestProductsByPartner(134018);
  }

  getMarketingSourcesList() {
    return <any>this._api.getAuth(`projects/types/1`).pipe(map((res: any) => res.body.entities));
  }

  getMarketingClientTypesList() {
    // K_Tipas
    return <any>this._api.getAuth(`projects/types/2`).pipe(map((res: any) => res.body.entities));
  }

  getAllMarketingTasks(params: any) {
    const pars: any = {};
    pars.dateTo = params.to;
    pars.dateFrom = params.from;
    pars.startFrom = params.startFrom;
    pars.pageLength = params.pageLength;
    pars.orderBy = params.orderBy;
    pars.orderDir = params.orderDir;
    params.search ? pars.filter = params.search : null;
    pars.statesBitMask = getStateBitMask(params);
    pars.clientTypeIdStr = params.clientTypesList;
    pars.sourceIdStr = params.sourcesList;
    // pars.taskTypeId = params.taskTypeId;
    pars.taskTypeStr = params.taskTypeStr;
    const filteredExecutors = this.filterExecutorStr(params.executors);
    if (filteredExecutors) {
      pars.executorStr = filteredExecutors;
    }
    pars.productStr = params.products;
    // pars.campaignsId = null;
    this.getAllMarketingTasksSavedPars = pars;
    return <any>this._api.getAuth(`tasks/campaign/task`, pars).pipe(map((res: any) => res.body));
  }

  getAllMarketingTasksForExport(): Observable<any[]> {
    return <any>this._api.getAuth('tasks/campaign/task', { ...this.getAllMarketingTasksSavedPars, startFrom: 0, pageLength: 999999 }).pipe(map((res: any) => res.body));
  }

  getAllMarketingCampaignTasksForExport(): Observable<any[]>{
    return <any>this._api.getAuth('tasks/campaign/task', { ...this.getCampaignsMarketingTasksSavedPars, startFrom: 0, pageLength: 999999 }).pipe(map((res: any) => res.body));
  }

  getCampaignsMarketingTasks(id, params: any) {
    const pars: any = {};
    pars.dateTo = params.to;
    pars.campaignsId = id;
    pars.dateFrom = params.from;
    pars.startFrom = params.startFrom;
    pars.pageLength = params.pageLength;
    pars.orderBy = params.orderBy;
    pars.orderDir = params.orderDir;
    params.search ? pars.filter = params.search : null;
    pars.statesBitMask = getStateBitMask(params);
    pars.clientTypeIdStr = params.clientTypesList;
    pars.sourceIdStr = params.sourcesList;
    // pars.taskTypeId = params.taskTypeId;
    pars.taskTypeStr = params.taskTypeStr;
    const filteredExecutors = this.filterExecutorStr(params.executors);
    if (filteredExecutors) {
      pars.executorStr = filteredExecutors;
    }
    pars.productStr = params.products;
    this.getCampaignsMarketingTasksSavedPars = pars;
    // params.partnerId !== undefined ? pars.partnerId = params.partnerId : null;
    // params.userId !== undefined ? pars.userId = params.userId : null;
    return <any>this._api.getAuth(`tasks/campaign/task`, pars).pipe(map((res: any) => res.body));
  }

  getCampaignsMarketingTasksForExport(): Observable<any[]> {
    return <any>this._api.getAuth('tasks/campaign/task', { ...this.getCampaignsMarketingTasksSavedPars, startFrom: 0, pageLength: 999999 }).pipe(map((res: any) => res.body));
  }

  deleteCampaignsTasks(campaignsId) {
    return <any>this._api.deleteAuth(`tasks/campaign/${campaignsId}/task`).pipe(map((res: any) => res.body));
  }

  getCampaignsParticipantList(id) {
    return <any>this._api.getAuth(`tasks/campaign/${id}/participants`).pipe(map((res: any) => res.body.entities));
  }

}